// src/Navegación/Navigation.js
import React, {useState, useEffect, useRef} from 'react';
import {Link} from 'react-router-dom';
import './Navigation.css';
import profileIcon from '../Icons/profile-menu.png';
import homeIcon from '../Icons/home.png';
import searchIcon from '../Icons/buscador.png';
import chatIcon from '../Icons/chatAI.png';
import savedIcon from '../Icons/saved1.png';
import {useNotifications} from '../hooks/useNotifications';
import ProfileMenu from './components/ProfileMenu';
import NotificationsModal from '../Community/NotificationsModal';

const Navigation = ({userId, onLogout}) => {
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const [showAllNotifications, setShowAllNotifications] = useState(false);
    const profileMenuRef = useRef(null);

    const {notifications, unreadNotifications, markAllAsRead} = useNotifications(userId);

    // Cerrar menú al hacer click fuera
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                profileMenuRef.current &&
                !profileMenuRef.current.contains(event.target)
            ) {
                setShowProfileMenu(false);
           }
       };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
       };
   }, []);

    return (
        <nav className="bottom-nav-bar">
            <div className="nav-icons">
                <Link to="/community" className="nav-link">
                    <img src={homeIcon} alt="Comunidad" className="nav-icon" />
                </Link>
                <Link to="/search" className="nav-link">
                    <img src={searchIcon} alt="Buscador de recetas" className="nav-icon nav-search-icon" />
                </Link>
                <Link to="/chat" className="nav-link">
                    <img src={chatIcon} alt="Cookychat" className="nav-icon chatai-icon" />
                </Link>
                <Link to="/favorite-recipes" className="nav-link">
                    <img src={savedIcon} alt="Recetas guardadas" className="nav-icon" />
                </Link>
                <span className="nav-link profile-link" style={{position: 'relative'}}>
                    <img
                        src={profileIcon}
                        alt="Perfil"
                        className="nav-icon profile-icon"
                        onClick={() => setShowProfileMenu(v => !v)}
                    />
                    {unreadNotifications && (
                        <span className="notification-dot"></span>
                    )}
                </span>
            </div>
            {showProfileMenu && (
                <>
                  <div className="profile-menu-overlay" onClick={() => setShowProfileMenu(false)} />
                  <div ref={profileMenuRef}>
                    <ProfileMenu
                      onLogout={onLogout}
                      setShowProfileMenu={setShowProfileMenu}
                      unreadNotifications={unreadNotifications}
                      onShowNotifications={() => setShowAllNotifications(true)}
                    />
                  </div>
                </>
            )}
            {showAllNotifications && (
                <NotificationsModal
                    notifications={notifications}
                    onClose={() => setShowAllNotifications(false)}
                    markAllAsRead={markAllAsRead}
                />
            )}
        </nav>
    );
};

export default Navigation;